import { NgModule } from '@angular/core';
import { RoleEditComponent } from './role-edit.component';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@fi-app/components/components.module';
import { RoleEditAfterSaveDialogComponent } from './role-edit-after-save-dialog/role-edit-after-save-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RoleNewLayoutModule } from '@fi-app/role/role-new-layout/role-new-layout.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FormsModule,
        ComponentsModule,
        MatCheckboxModule,
        MatCardModule,
        MatIconModule,
        MatTabsModule,
        RoleNewLayoutModule,
        FiPageHeaderModule,
        UIRouterModule,
    ],
    declarations: [RoleEditComponent, RoleEditAfterSaveDialogComponent],
    exports: [RoleEditComponent],
})
export class FiRoleEditModule {}
